import { Sprite } from '@ktag/styleguide/dist/react';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

export type MuniTab = 'map' | 'table';

interface Props {
  selectedTab: MuniTab;
  setSelectedTab: (tab: MuniTab) => void;
  isAbsolute?: boolean;
}

const MapSwitch = ({ selectedTab, setSelectedTab, isAbsolute }: Props) => {
  const { t } = useTranslation('wap');
  return (
    <div className={classNames('mapswitch', { 'mapswitch--absolute': isAbsolute })}>
      <button
        type="button"
        className={classNames('mapswitch__button', {
          'mapswitch__button--inactive': selectedTab === 'table',
        })}
        onClick={() => setSelectedTab('map')}
      >
        <Sprite id="map" />
        {t('proportional_map_switch_map')}
      </button>
      <div className="mapswitch__separator" />
      <button
        type="button"
        className={classNames('mapswitch__button', {
          'mapswitch__button--inactive': selectedTab === 'map',
        })}
        onClick={() => setSelectedTab('table')}
      >
        <Sprite id="table" />
        {t('proportional_map_switch_table')}
      </button>
    </div>
  );
};

export default MapSwitch;
